<div>
    <app-table-component
        [data]="walletTransactionHistoryList()"
        [columns]="tableColumns"
        [totalRecords]="totalRecords()"
        [rows]="rows"
        [first]="first"
        (pageChange)="onPageChange($event)"
        [showColumnSelector]="false"
        [showClearFilters]="false"
        [searchControl]="searchControl"
        [customFilters]="[operationTypeFilter, displayStatusFilter, createdDateFilter]" />
</div>
